// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.device-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  margin-bottom: 24px;
  background: #f8f9fa;
  border-radius: 8px;
}

.form-container {
  padding: 0 16px;
}

.form-group {
  margin-bottom: 20px;
  position: relative;
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-actions {
  margin-top: 24px;
  padding: 16px;
  border-top: 1px solid #e9ecef;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e2e5e8;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:hover {
  border-color: var(--bs-primary);
}

.dropdown-container {
  position: static;
  width: 100%;
}

.dropdown-container__content {
  width: 100% !important;
  max-height: 300px;
  overflow-y: auto;
  position: absolute;
  z-index: 1000;
  background: white;
  border: 1px solid #e2e5e8;
  border-radius: 0.375rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 0;
  padding: 0.5rem 0;
  left: 0;
}

.dropdown-container__content.top-start {
  bottom: 100%;
  margin-bottom: 0.5rem;
}

.dropdown__item {
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
}

.dropdown__item:hover {
  background-color: var(--bs-primary-bg-subtle);
}

.content__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.avatar-sm {
  width: 32px;
  height: 32px;
}

.hover-shadow {
  transition: box-shadow 0.3s ease, transform 0.2s ease;
}

.hover-shadow:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

.pagination {
  margin: 0;
  padding: 0;
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.page-item {
  margin: 0;
  list-style: none;
}

.page-link {
  min-width: 36px;
  height: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px !important;
  font-weight: 500;
  font-size: 0.875rem;
  color: #00b4f3;
  background: #ffffff;
  border: 1px solid #e2e5e8;
  transition: all 0.2s ease-in-out;
}

.page-link:hover:not(:disabled) {
  background: rgba(12, 132, 121, 0.1);
  color: #00b4f3;
  border-color: #00b4f3;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(12, 132, 121, 0.1);
}

.page-item.active .page-link {
  background: #00b4f3;
  color: white;
  border-color: #00b4f3;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(12, 132, 121, 0.2);
}

.page-item.disabled .page-link {
  background: #f8f9fa;
  color: #6c757d;
  border-color: #e2e5e8;
  opacity: 0.75;
  cursor: not-allowed;
  pointer-events: none;
}

.pagination-info {
  text-align: center;
  color: #6c757d;
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.pagination-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-top: 1.5rem;
  padding: 1.25rem;
  background: rgba(12, 132, 121, 0.05);
  border: 1px solid rgba(12, 132, 121, 0.1);
  border-radius: 12px;
}

.page-header-card {
  background: linear-gradient(135deg, var(--m-card-background-color, #ffffff) 0%, var(--m-surface-subtle, #f8f9fa) 100%);
  border: 1px solid var(--m-border, #e9ecef);
  border-radius: 16px;
  box-shadow: var(--m-box-shadow, 0 4px 20px rgba(0, 0, 0, 0.08));
  color: var(--m-text);
  overflow: hidden;
  position: relative;
}

.page-header-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #00b4f3 0%, #4fd1c5 100%);
}

@media (max-width: 576px) {
  .pagination {
    gap: 2px;
  }
  .page-link {
    min-width: 32px;
    height: 32px;
    font-size: 0.75rem;
  }
  .pagination-container {
    padding: 0.75rem;
    margin-top: 1rem;
  }
}
/* Models Modal Styles */
.models-summary-simple {
  display: flex;
  gap: 1.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.summary-label {
  font-size: 14px;
  font-weight: 500;
  color: #495057;
}

.summary-value {
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
}

.summary-value.text-success {
  color: #28a745;
}

.model-item-simple {
  padding: 0.75rem 0;
  border-bottom: 1px solid #e9ecef;
}

.model-item-simple:last-child {
  border-bottom: none;
}

.model-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.model-name-simple {
  font-size: 14px;
  font-weight: 500;
  color: #1a202c;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.empty-models-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

.empty-icon {
  color: #cbd5e0;
  margin-bottom: 0.5rem;
}

.empty-text {
  font-size: 14px;
  color: #6c757d;
}

/* Filters block (Devices–style card + top-filters row + dropdown grid) */
.top-filters {
  width: 100%;
}
@media (max-width: 768px) {
  .top-filters > .d-flex.justify-content-between {
    flex-direction: column;
    align-items: stretch !important;
    gap: 0.75rem;
    width: 100%;
  }
  .top-filters > .d-flex.justify-content-between .btn {
    width: 100%;
  }
}

.list-filters__panel {
  padding: 0;
  background: transparent;
  border-top: none;
  width: 100%;
}

.list-filters__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.25rem;
  align-items: flex-end;
  width: 100%;
}
@media (max-width: 768px) {
  .list-filters__grid {
    flex-direction: column;
    align-items: stretch;
  }
}

.list-filters__field {
  min-width: 0;
  flex: 1 1 200px;
  max-width: 100%;
  box-sizing: border-box;
}
@media (max-width: 768px) {
  .list-filters__field {
    flex: 1 1 100%;
    min-width: 100%;
  }
}

.list-filters__control {
  width: 100%;
  background: #fff;
  border: 1px solid #e2e5e8;
  border-radius: 8px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.list-filters__control .dropdown {
  width: 100%;
}
.list-filters__control .dropdown__trigger {
  width: 100%;
  box-sizing: border-box;
  border: none;
  box-shadow: none;
}
.list-filters__control .m-select {
  margin-bottom: 0;
}
.list-filters__control .m-select-selected {
  border: none !important;
  box-shadow: none !important;
}
.list-filters__control:hover {
  border-color: #cfd8e3;
}
.list-filters__control:focus-within {
  border-color: rgba(13, 110, 253, 0.45);
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.12);
}

.list-filters__footer {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
@media (max-width: 768px) {
  .list-filters__footer {
    justify-content: stretch;
  }
  .list-filters__footer .btn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/pages/DeviceSales/DeviceSales.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,mBAAA;EACA,kBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,aAAA;EACA,6BAAA;AAEF;;AACA;EACE,cAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,uBAAA;EACA,wEACE;AACJ;;AAGA;EACE,+BAAA;AAAF;;AAGA;EACE,gBAAA;EACA,WAAA;AAAF;;AAGA;EACE,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,SAAA;EACA,iBAAA;EACA,OAAA;AAAF;;AAGA;EACE,YAAA;EACA,qBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;AAAF;;AAGA;EACE,6CAAA;AAAF;;AAGA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,qDACE;AADJ;;AAKA;EACE,wDAAA;EACA,2BAAA;AAFF;;AAKA;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAFF;;AAKA;EACE,SAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;AAFF;;AAKA;EACE,mCAAA;EACA,cAAA;EACA,qBAAA;EACA,2BAAA;EACA,6CAAA;AAFF;;AAKA;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;EACA,6CAAA;AAFF;;AAKA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yCAAA;EACA,mBAAA;AAFF;;AAKA;EACE,sHAAA;EAKA,0CAAA;EACA,mBAAA;EACA,+DAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AANF;;AASA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,4DAAA;AANF;;AASA;EACE;IACE,QAAA;EANF;EASA;IACE,eAAA;IACA,YAAA;IACA,kBAAA;EAPF;EAUA;IACE,gBAAA;IACA,gBAAA;EARF;AACF;AAWA,wBAAA;AACA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,kBAAA;EACA,gCAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AATF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AATF;;AAYA;EACE,cAAA;EACA,qBAAA;AATF;;AAYA;EACE,eAAA;EACA,cAAA;AATF;;AAYA,yEAAA;AACA;EACE,WAAA;AATF;AAWE;EACE;IACE,sBAAA;IACA,+BAAA;IACA,YAAA;IACA,WAAA;EATJ;EAWI;IACE,WAAA;EATN;AACF;;AAcA;EACE,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AAXF;;AAcA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;AAXF;AAaE;EAPF;IAQI,sBAAA;IACA,oBAAA;EAVF;AACF;;AAaA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AAVF;AAYE;EANF;IAOI,cAAA;IACA,eAAA;EATF;AACF;;AAYA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wDACE;AAVJ;AAaE;EACE,WAAA;AAXJ;AAcE;EACE,WAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AAZJ;AAeE;EACE,gBAAA;AAbJ;AAgBE;EACE,uBAAA;EACA,2BAAA;AAdJ;AAiBE;EACE,qBAAA;AAfJ;AAkBE;EACE,sCAAA;EACA,8CAAA;AAhBJ;;AAoBA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;AAjBF;AAmBE;EARF;IASI,wBAAA;EAhBF;EAkBE;IACE,WAAA;EAhBJ;AACF","sourcesContent":[".device-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  margin-bottom: 24px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.form-container {\n  padding: 0 16px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n  position: relative;\n}\n\n.form-group:last-child {\n  margin-bottom: 0;\n}\n\n.form-actions {\n  margin-top: 24px;\n  padding: 16px;\n  border-top: 1px solid #e9ecef;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #e2e5e8;\n  border-radius: 0.375rem;\n  transition:\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n}\n\n.form-control:hover {\n  border-color: var(--bs-primary);\n}\n\n.dropdown-container {\n  position: static;\n  width: 100%;\n}\n\n.dropdown-container__content {\n  width: 100% !important;\n  max-height: 300px;\n  overflow-y: auto;\n  position: absolute;\n  z-index: 1000;\n  background: white;\n  border: 1px solid #e2e5e8;\n  border-radius: 0.375rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin: 0;\n  padding: 0.5rem 0;\n  left: 0;\n}\n\n.dropdown-container__content.top-start {\n  bottom: 100%;\n  margin-bottom: 0.5rem;\n}\n\n.dropdown__item {\n  padding: 8px 16px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n}\n\n.dropdown__item:hover {\n  background-color: var(--bs-primary-bg-subtle);\n}\n\n.content__list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.avatar-sm {\n  width: 32px;\n  height: 32px;\n}\n\n.hover-shadow {\n  transition:\n    box-shadow 0.3s ease,\n    transform 0.2s ease;\n}\n\n.hover-shadow:hover {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n  transform: translateY(-2px);\n}\n\n.pagination {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.page-item {\n  margin: 0;\n  list-style: none;\n}\n\n.page-link {\n  min-width: 36px;\n  height: 36px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px !important;\n  font-weight: 500;\n  font-size: 0.875rem;\n  color: #00b4f3;\n  background: #ffffff;\n  border: 1px solid #e2e5e8;\n  transition: all 0.2s ease-in-out;\n}\n\n.page-link:hover:not(:disabled) {\n  background: rgba(12, 132, 121, 0.1);\n  color: #00b4f3;\n  border-color: #00b4f3;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(12, 132, 121, 0.1);\n}\n\n.page-item.active .page-link {\n  background: #00b4f3;\n  color: white;\n  border-color: #00b4f3;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(12, 132, 121, 0.2);\n}\n\n.page-item.disabled .page-link {\n  background: #f8f9fa;\n  color: #6c757d;\n  border-color: #e2e5e8;\n  opacity: 0.75;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.pagination-info {\n  text-align: center;\n  color: #6c757d;\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n}\n\n.pagination-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  padding: 1.25rem;\n  background: rgba(12, 132, 121, 0.05);\n  border: 1px solid rgba(12, 132, 121, 0.1);\n  border-radius: 12px;\n}\n\n.page-header-card {\n  background: linear-gradient(\n    135deg,\n    var(--m-card-background-color, #ffffff) 0%,\n    var(--m-surface-subtle, #f8f9fa) 100%\n  );\n  border: 1px solid var(--m-border, #e9ecef);\n  border-radius: 16px;\n  box-shadow: var(--m-box-shadow, 0 4px 20px rgba(0, 0, 0, 0.08));\n  color: var(--m-text);\n  overflow: hidden;\n  position: relative;\n}\n\n.page-header-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #00b4f3 0%, #4fd1c5 100%);\n}\n\n@media (max-width: 576px) {\n  .pagination {\n    gap: 2px;\n  }\n\n  .page-link {\n    min-width: 32px;\n    height: 32px;\n    font-size: 0.75rem;\n  }\n\n  .pagination-container {\n    padding: 0.75rem;\n    margin-top: 1rem;\n  }\n}\n\n/* Models Modal Styles */\n.models-summary-simple {\n  display: flex;\n  gap: 1.5rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.summary-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.summary-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.summary-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.summary-value.text-success {\n  color: #28a745;\n}\n\n.model-item-simple {\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.model-item-simple:last-child {\n  border-bottom: none;\n}\n\n.model-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.model-name-simple {\n  font-size: 14px;\n  font-weight: 500;\n  color: #1a202c;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.empty-models-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n}\n\n.empty-icon {\n  color: #cbd5e0;\n  margin-bottom: 0.5rem;\n}\n\n.empty-text {\n  font-size: 14px;\n  color: #6c757d;\n}\n\n/* Filters block (Devices–style card + top-filters row + dropdown grid) */\n.top-filters {\n  width: 100%;\n\n  @media (max-width: 768px) {\n    > .d-flex.justify-content-between {\n      flex-direction: column;\n      align-items: stretch !important;\n      gap: 0.75rem;\n      width: 100%;\n\n      .btn {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.list-filters__panel {\n  padding: 0;\n  background: transparent;\n  border-top: none;\n  width: 100%;\n}\n\n.list-filters__grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem 1.25rem;\n  align-items: flex-end;\n  width: 100%;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.list-filters__field {\n  min-width: 0;\n  flex: 1 1 200px;\n  max-width: 100%;\n  box-sizing: border-box;\n\n  @media (max-width: 768px) {\n    flex: 1 1 100%;\n    min-width: 100%;\n  }\n}\n\n.list-filters__control {\n  width: 100%;\n  background: #fff;\n  border: 1px solid #e2e5e8;\n  border-radius: 8px;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n\n  .dropdown {\n    width: 100%;\n  }\n\n  .dropdown__trigger {\n    width: 100%;\n    box-sizing: border-box;\n    border: none;\n    box-shadow: none;\n  }\n\n  .m-select {\n    margin-bottom: 0;\n  }\n\n  .m-select-selected {\n    border: none !important;\n    box-shadow: none !important;\n  }\n\n  &:hover {\n    border-color: #cfd8e3;\n  }\n\n  &:focus-within {\n    border-color: rgba(13, 110, 253, 0.45);\n    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.12);\n  }\n}\n\n.list-filters__footer {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e9ecef;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n\n  @media (max-width: 768px) {\n    justify-content: stretch;\n\n    .btn {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
